import { type QuadrilateralDimensions } from '~/_shared/types/coordinateSystem/coordinateSystem';

export const MAX_TILE_DIMENSIONS: QuadrilateralDimensions = { width: 64, height: 64 };
export const IMAGE_SELECTOR_PADDING = 8;
